interface StarRatingInputProps {
	value: number;
	onChange: (rating: number) => void;
	disabled?: boolean;
	size?: "default" | "large";
	align?: "left" | "center";
}

export default function StarRatingInput({
	value,
	onChange,
	disabled = false,
	size = "default",
	align = "center",
}: StarRatingInputProps) {
	const iconSize = size === "large" ? "w-12 h-12 md:w-14 md:h-14" : "w-8 h-8";
	const justifyClass = align === "left" ? "justify-start" : "justify-center";

	return (
		<div className={`flex items-center ${justifyClass} gap-1 md:gap-2`}>
			{[1, 2, 3, 4, 5].map((star) => (
				<button
					key={star}
					type="button"
					onClick={() => !disabled && onChange(star)}
					className={`p-1 transition-all duration-150 ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:scale-110 group"}`}
					aria-label={`Rate ${star} stars`}
					disabled={disabled}
				>
					{star <= value ? (
						<div
							className={iconSize}
							style={{
								backgroundColor: "var(--color-accent)",
								maskImage: "url(/images/star-filled.svg)",
								maskSize: "contain",
								maskRepeat: "no-repeat",
								maskPosition: "center",
								WebkitMaskImage: "url(/images/star-filled.svg)",
								WebkitMaskSize: "contain",
								WebkitMaskRepeat: "no-repeat",
								WebkitMaskPosition: "center",
							}}
						/>
					) : (
						<div
							className={`${iconSize} transition-colors ${!disabled && "group-hover:opacity-60"}`}
							style={{
								backgroundColor: "#d1d5db",
								maskImage: "url(/images/star-outline.svg)",
								maskSize: "contain",
								maskRepeat: "no-repeat",
								maskPosition: "center",
								WebkitMaskImage:
									"url(/images/star-outline.svg)",
								WebkitMaskSize: "contain",
								WebkitMaskRepeat: "no-repeat",
								WebkitMaskPosition: "center",
							}}
						/>
					)}
				</button>
			))}
		</div>
	);
}
